import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        // Customize paragraph rendering
        // Adds headings for eligibility criteria
        p: ({ node, children, ...props }) => {
          const text = children;
          if (typeof text === 'string') {
            // Check for specific criteria to render as headings
            const trimmedText = text.trim();
            if (trimmedText === 'Inclusion Criteria:' || trimmedText === 'Exclusion Criteria:') {
              return (
                <h4 className="mt-4 first:mt-0 mb-0 p-0" {...props}>
                  {trimmedText}
                </h4>
              );
            }
          }
          return (
            <p className="mt-2 mb-2" {...props}>
              {children}
            </p>
          );
        },

        // Customize unordered list rendering
        ul: ({ node, ...props }) => (
          <ul className="list-disc list-outside mt-4 mb-4 last:mb-0 first:mt-0" {...props} />
        ),

        // Customize list item rendering to remove inner <p> margins
        li: ({ node, children, ...props }) => {
          return (
            <li className="mb-4 last:mb-0" {...props}>
              {children}
            </li>
          );
        },
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
